/// <reference types="vite-plugin-svgr/client" />
// Must stay the first import (pinned in .prettierrc): configures Zod before any schema exists.
import "./zodConfig";
// PRTL-1392: self-hosted Roboto (variable weight axis, so 300–700 are all real).
import "@fontsource-variable/roboto";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

function isLocalHost(hostname: string): boolean {
    return (
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        hostname === "[::1]" ||
        hostname.endsWith(".local")
    );
}

Sentry.init({
    dsn: "https://7a3c38d324c9880712e69658ddb371bf@o4508919719723008.ingest.us.sentry.io/4508919925178369",
    // Off on local hosts even for production-mode builds (`vite build` +
    // `vite preview`, screenshot runs): those would report as production.
    enabled:
        import.meta.env.VITE_SENTRY_ENABLED === "true" && !isLocalHost(window.location.hostname),
    // Sentry 11 dataCollection: user info, headers and cookies keep the
    // defaults (keys and tokens are always filtered). Request/response bodies
    // are OFF (Phil, Oct 5): fetch bodies include the tRPC login, 2FA and
    // password calls and private client data.
    dataCollection: {
        httpBodies: [],
    },
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "development",
    // Sentry 11: logs (Sentry.logger.*) are always on; enableLogs was removed.
    tracesSampleRate: 0.1,
    integrations: [
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        Sentry.captureConsoleIntegration({ levels: ["error"] }),
    ],
});

createRoot(document.getElementById("react")!).render(<App />);
